import { render } from "./phone-number.vue?vue&type=template&id=86280532&scoped=true"
import script from "./phone-number.vue?vue&type=script&lang=js"
export * from "./phone-number.vue?vue&type=script&lang=js"

import "./phone-number.vue?vue&type=style&index=0&id=86280532&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86280532"]])

export default __exports__